// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3GSSI","col":"Table_col__3x7fw","fulfillmentStatus":"Table_fulfillmentStatus__2ic5i","emailCol":"Table_emailCol__2cfM7"};